import { useCallback, useEffect, useRef, useState } from 'react'

/**
 * Копирование в буфер с отметкой «скопировано».
 *
 * Копируется РОВНО переданная строка, без форматирования. Разбить
 * сумму на разряды для красоты и скопировать красивое означает
 * отправить не ту сумму: допуск по недоплате нулевой, и заявка
 * застрянет навсегда.
 */
export function useCopy(resetMs = 1800) {
  const [copied, setCopied] = useState<string | null>(null)
  const timer = useRef<number | null>(null)

  useEffect(
    () => () => {
      if (timer.current !== null) window.clearTimeout(timer.current)
    },
    [],
  )

  const copy = useCallback(
    async (value: string, key: string) => {
      try {
        await navigator.clipboard.writeText(value)
      } catch {
        // Буфер недоступен: не тот протокол (http без localhost),
        // отказано в разрешении, старый браузер. Молча ничего
        // не делать нельзя — человек решит, что скопировалось.
        window.prompt('Скопируйте вручную:', value)
        return
      }
      setCopied(key)
      if (timer.current !== null) window.clearTimeout(timer.current)
      timer.current = window.setTimeout(() => setCopied(null), resetMs)
    },
    [resetMs],
  )

  return { copied, copy }
}
